import { render, staticRenderFns } from "./BreakingBanner.vue?vue&type=template&id=5d4b6dc3&scoped=true&"
import script from "./BreakingBanner.vue?vue&type=script&lang=js&"
export * from "./BreakingBanner.vue?vue&type=script&lang=js&"
import style0 from "./BreakingBanner.vue?vue&type=style&index=0&id=5d4b6dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b6dc3",
  null
  
)

export default component.exports